import styled from 'styled-components'
import CloseIcon from '../../UI/Icons/CloseIcon'
import CheckIcon from '../../UI/Icons/CheckIcon'
import { device } from '../../../utils/helpers'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  background: #4d4d4d;
  text-align: center;
  position: relative;
`

export const Title = styled.h2`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  padding: 25px;
  color: #fff;
  font-size: 24px;

  @media ${device.mobileMinL} {
    font-size: 28px;
  }

  @media ${device.tablet} {
  ${''/* 42, 25 */}
    font-size: 2.1875vw;
    padding: 1.3020833333333335vw;
  }

  ${'' /* @media ${device.tablet} {
    font-size: 32px;
  }

  @media ${device.laptop} {
    font-size: 36px;
    padding: 30px;
  }

  @media ${device.laptopL} {
    font-size: 48px;
  } */}
`

export const Heading = styled.h5`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 20px;
  padding: 0.5rem 0;

  @media ${device.tablet} {
    font-size: 16px;
  }

  @media ${device.laptop} {
    font-size: 18px;
  }

  @media ${device.laptopL} {
    font-size: 20px;
  }
`

export const Price = styled.h3`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 24px;

  @media ${device.tablet} {
    font-size: 1.875vw;
  }
`

export const Icon = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;

  @media ${device.tablet} {
    width: 1.5625vw;
    right: 0.5208333333333334vw;
    top: 0.5208333333333334vw;
  }

  &:hover {
    fill: ${props => props.theme.color.hoverPrimary};
  }
`

export const CheckMark = styled(CheckIcon)`
  width: 10px;
  stroke: #4d4d4d;

  @media ${device.mobileMinL} {
    width: 15px;
  }

  @media ${device.tablet} {
    width: 1.5625vw;
  }
`

export const Content = styled.div`
  padding: 45px 60px;
  height: auto;
  justify-content: space-between;
  display: none;

  @media ${device.tablet} {
    display: flex;
    padding: 25px 40px;
  }

  @media ${device.laptop} {
    padding: 45px 60px;
  }

  ${'' /* @media ${device.laptop} {
    display: flex;
  } */}
`

export const Left = styled.div`
  width: 48%;
`

export const Right = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 12px;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }

  @media ${device.laptopL} {
    font-size: 15px;
  }

  @media ${device.desktop} {
    font-size: 17px;
  }
`

export const Para = styled.p`
  font-size: 16px;
  padding: 3px 0;

  @media ${device.tablet} {
    font-size: 12px;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }

  @media ${device.laptopL} {
    font-size: 15px;
  }

  @media ${device.desktop} {
    font-size: 17px;
  }
`

export const Table = styled.table`
  border: 1px solid black;
  border-collapse: collapse;
  width: 100%;
  font-family: 'BarlowSemiBold';
  font-size: 16px;
  margin-top: 15px;
  margin-bottom: 30px;

  th, td {
    padding: 8px 15px;
    border: 1px solid black;
  }

  th {
    text-align: center;
  }

  @media ${device.tablet} {
    ${'' /* font-size: 16px;
    margin-top: 10px;
    margin-bottom: 30px; */}
    font-size: 0.8333333333333334vw;
    margin-top: 0.5208333333333334vw;
    margin-bottom: 1.5625vw;

    th, td {
      padding: 0.4166666666666667vw 0.78125vw;
    }
  }
`

export const Button = styled.button`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  font-size: 16px;
  color: #fff;
  border: 5px solid #4d4d4d;
  background-color: #4d4d4d;
  padding: 11px 55px;
  text-transform: uppercase;
  transition: all 0.5s ease;
  cursor: pointer;
  width: 100%;
  margin-top: 20px;

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  @media ${device.mobileMinL} {
    font-size: 20px;
  }

  @media ${device.tablet} {
    ${'' /* font-size: 36px;
    margin-top: 100px; */}
    font-size: 1.875vw;
    margin-top: 0;
    padding: 0.5729166666666667vw 2.8645833333333335vw;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 190px;

  @media ${device.mobileMinL} {
    height: 220px;
  }

  @media ${device.tablet} {
    height: 190px;
    ${'' /* height: 14.166666666666666VW; */}
  }

  @media ${device.laptop} {
    height: 220px;
    ${'' /* height: 14.166666666666666VW; */}
  }

  @media ${device.laptopL} {
    height: 260px;
    ${'' /* height: 14.166666666666666VW; */}
  }
`

export const Thumbnails = styled.div`
  display: flex;
  ${'' /* width: 100%; */}
  justify-content: ${props => props.imgCount < 3 ? 'space-evenly' : 'space-between'};
  padding-top: 10px;
  padding-bottom: 15px;

  @media ${device.tablet} {
    ${'' /* padding-top: 20px;
    padding-bottom: 30px; */}
    padding-top: 1.0416666666666667vw;
    padding-bottom: 1.5625vw;
  }
`

export const Thumb = styled.img`
  width: 30%;
  height: 60px;

  @media ${device.tablet} {
    width: 32%;
    ${'' /* height: 4.427083333333334vw; */}
  }

  @media ${device.laptop} {
    height: 85px;
    ${'' /* height: 4.427083333333334vw; */}
  }
`

export const Section = styled.div`
  padding-bottom: 15px;

  @media ${device.tablet} {
    padding-bottom: 0.78125vw;
  }
`

export const UList = styled.ul`
  padding-left: 15px;

  @media ${device.tablet} {
    padding-bottom: 0.78125vw;
    line-height: 1.2em;
  }
`

export const MobileContent = styled.div`
  padding: 20px 25px;

  @media ${device.tablet} {
    display: none;
  }
`

export const TableWrapper = styled.div`
  overflow-x: auto;
`

export const MobileBottom = styled.div`
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/Helpers/Info/InfoCommon.js